<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">绑定手机</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <div class="weui-toptips weui-toptips_warn" :style="{display:item.checked?'block':'none'}" v-for="(item,index) in showTopTips"
      v-if="item.checked">{{item.text}}
    </div>
    <div class="banner_logo">
      <img class="banner_icon" :src="logoImg" />
    </div>
    <div class="changephone_center">
      <div class="phone_inputfrom">
        <div class="phone_text">手机号码</div>
        <input class="phone_input" placeholder="请输入手机号码" v-model="phoneNum" @input="input('phoneNum')" />
      </div>
      <div class="yanzheng_inputfrom">
        <div class="phone_text">验证码</div>
        <div class="yanzheng_input">
          <input class="yanzheng_inputyz" type="number" placeholder="请输入验证码" v-model="phoneCode" @input="input('phoneCode')" />
          <div class="yanzheng_get" @click='!currentTime ? tap("getPhoneCode") : ""'> {{ currentTime ? currentTime : "获取验证码" }}</div>
        </div>
        <!--  <div>{{phoneCodeStatus}}</div>phoneCodeStatus &&  -->
      </div>
      <!-- 支付 开始 -->
      <div class="page_button change_tijiao" @click="tap('changePhoneNum')">
        <div class="page_zhifu">提交</div>
      </div>
      <div class="xieyibox">
        <img class="xieyiimg" @click="changeAgree" v-if="agree" src="../../../static/checkdeicon.png" />
        <img class="xieyiimg" @click="changeAgree" v-else src="../../../static/checkicon.png" />
        <div class="xieyitest">我已阅读并同意<span style="color: #FD8C00" @click="toPrivacyAgree">《来来车服平台隐私政策》</span></div>
      </div>
      <!-- 支付 结束 -->
      <!-- 注意事项 开始 -->
<!--      <div class="change_mesg">-->
<!--        <div class="change_mesgtitle">-->
<!--          <img class="change_mesgimg" src="/static/newprojecticon/title.png" />-->
<!--          <div class="change_mesgtext">注意事项</div>-->
<!--        </div>-->
<!--        <div class="change_mesgtip">手机号只能绑定一次，无法改绑</div>-->
<!--        <div class="change_mesgtip">1、请认真核对充值号信息，对个人输入有误产生的售后问题概不受理。</div> -->
<!--      </div>-->
      <!-- 注意事项 结束 -->
<!--      隐私政策弹框 -->
<!--      <van-popup v-model="show">-->
<!--        <div class="yinsibox">-->
<!--          <div class="yinsititle">隐私政策</div>-->
<!--          <div class="yinsidetail">为了注册、登录优越服务，开发者将在获取你的明示同意后，收集你的微信昵称、头像。</div>-->
<!--          <div class="yinsidetail">为了快速填写地址，开发者将在获取你的明示同意后，收集你的位置信息。</div>-->
<!--          <div class="yinsidetail">开发者收集你选中的照片或视频信息，用于生成并保存海报图。</div>-->
<!--          <div class="yinsidetail">开发者使用你的通讯录 (仅写入) 权限，用于快递师傅与您取得联系，也用于客服需要与您确认信息的时候取得联系。</div>-->
<!--          <div class="yinsidetail">开发者收集你的发布内容，用于工作人员对您的需求进行策划分析。</div>-->
<!--          <div></div>-->
<!--          <div class="yinsidetail">客服电话：<a :href="'tel:' + phoneNumber">{{phoneNumber}}</a></div>-->
<!--        </div>-->
<!--      </van-popup>-->
    </div>

  </div>
</template>
<script>
  // import swal from 'sweetalert'
  import httper from '../../api/http';
  import httpers from '../../api/https';
  import {
    Dialog
  } from 'vant';
  var phone_mreg = /^1[2-9][0-9]{9}$/;
  export default {
    data() {
      return {
        login_code: null, //微信登录code
        isAdd: false, // 是否新增手机号码,默认为false
        phoneNum: '', // 全局变量获取原有手机号码,默认为空
        phoneCode: '', // 验证码,默认为空
        currentCode: '', // 接口获取正确的验证码,默认为空
        currentTime: '', // 验证码倒计时,默认为空
        phoneCodeStatus: false, // 手机领-验证码状态,默认为false
        showTopTips: [{
          text: '请填写正确的手机号码!',
          checked: false
        }, {
          text: '请输入验证码!',
          checked: false
        }, {
          text: '验证不一致，请重新获取!',
          checked: false
        }], // 错误提示列表
        buttonClicked: false, // 防止支付重复点击,默认为false
        phoneNum1: "", //原绑定手机号
        ischange: true,
        logoImg:"",
        agree:false,
        show:false,//隐私协议弹框
        phoneNumber: '',
        // isPrize:false
      }
    },
    created() {
     this.phoneNumber  = sessionStorage.getItem("phoneNumber")
      if (this.$route.query.phone) {
        this.phoneNum1 = this.$route.query.phone
        console.log("this.phoneNum1", this.phoneNum1)
        //this.ischange = true
        //this.phoneCodeStatus = phone_mreg.test(this.phoneNum)
      }

      let source = sessionStorage.getItem("source")
      this.request("getLogo",{
        source:source
      })

      // if(this.$route.query.isPrize){
      //   this.isPrize = this.$route.query.isPrize
      // }
    },
    mounted() {

    },
    methods: {
      pageReturn() {
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      openyinsi(){
        this.show = true
      },
      closeyinsi(){
        this.show = false
      },
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === 'number') {
            setTimeout(() => {
              this.buttonClicked = false
            }, duration)
          }
          resolve(true)
        })
      },
      changeAgree() {
        this.agree = !this.agree;
      },
      toUserAgree() {
        this.$router.push({
          path: "/userAgreement"
        })
      },
      toPrivacyAgree() {
        this.$router.push({
          path: "/privacyAgreement"
        })
      },
      /**
       * 接口名称：页面顶部展示错误提示
       * 场景说明：页面顶部展示2秒错误提示后隐藏，一般配合防止重复点击方法（buttonClicked），用于表单数据验证。
       * 接口说明：判断需验证的页面数据是否为true，若为true时页面顶部显示2秒错误提示（错误提示内容为错误提示列表的指定元素this.showTopTips[index].text
       * @param showStatus
       * @param index
       * @returns {boolean}
       */
      showTopTip(showStatus = false, index = 0) {
        if (!showStatus) return
        let showTopTips = this.showTopTips
        showTopTips[index].checked = true
        this.showTopTips = showTopTips

        setTimeout(() => {
          showTopTips[index].checked = false
          this.showTopTips = showTopTips
        }, 2000)
        return true
      },
      //键盘输入时触发
      input(type) {
        let that = this
        switch (type) {
          // 改变手机号码
          case 'phoneNum':
            that.phoneNum = this.phoneNum
            that.phoneCodeStatus = phone_mreg.test(this.phoneNum)
            break
            //改变验证码
          case 'phoneCode':
            that.phoneCode = this.phoneCode
            break
        }
      },
      // 点击触发
      tap(type, params = '') {
        let that = this
        let requestData = {}
        switch (type) {
          // 获取验证码
          case 'getPhoneCode':
            that.buttonClickedFun(1500)
            console.log("that.phoneCodeStatus && that.phoneNum", (that.phoneCodeStatus && that.phoneNum != ""))
            if (!that.phoneCodeStatus) {
              // that.showTopTip(!that.phoneCodeStatus,1)
              this.$toast({
                message: '请输入正确手机号码',
              });
              return
            }

            if (!that.phoneNum) {
              this.$toast({
                message: '请输入正确手机号码',
              });
              // that.showTopTip(!that.phoneNum, 1);
              return
            }
            // if (that.phoneNum==that.phoneNum1) {
            //     // that.showTopTip(!that.phoneNum, 1);
            //   return
            // }
            if (that.phoneCodeStatus && (that.phoneNum != "")) {
              requestData.mobile = that.phoneNum
              this.request('sendCode', requestData)
            }
            break
            // 绑定手机号码
          case 'changePhoneNum':
            that.buttonClickedFun(1500)

            console.log("that.phoneCode", that.phoneCode)
            console.log("that.currentCode", that.currentCode)
            if (that.showTopTip(!phone_mreg.test(that.phoneNum))) {
              that.buttonClicked = false
              return
            }
            if (that.showTopTip(that.phoneCode == '', 1)) {
              that.buttonClicked = false

              return
            }
            if (that.showTopTip(that.phoneCode != that.currentCode, 2)) {
              that.buttonClicked = false
              return
            }
            if (!this.agree) {
              this.$toast({
                message: '请先阅读并同意《优越服务平台隐私政策》',
              });
              return
            }
            Dialog.confirm({
                title: '提示',
                message: '每个微信号只能绑定一次手机号码，是否确认绑定?',
              })
              .then(() => {
                requestData.mobile = that.phoneNum
                console.log("requestdata",requestData)
                that.request('bindMobile', requestData)
                that.buttonClicked = false
              })
              .catch(() => {
                return false;
              });
            break
        }
      },
      // 调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
			// 获取logo
			case 'getLogo':
			  httper.get('index/get-agent', requestData, res => {
			    console.log("res", res)
			    if (res.code == 0) {
			      that.logoImg = res.data.logo
			    } else {
			      this.$toast({
			        message: res.message || '操作失败',
			      });
			    }
			  }, false)
			  break
          // 发送短息验证码
          case 'sendCode':
            httpers.post('msg/send-code', requestData, res => {
              console.log('code：', res.data)
              if (res.code == 0) {
                that.currentCode = res.data
                this.$toast({
                  message: '验证码已发送',
                });
                // 倒计时
                let time = 91
                let interval = setInterval(() => {
                  time--
                  if (time > 10) {
                    that.currentTime = time + '秒'
                  }
                  if (time > 0 && time <= 10) {
                    that.currentTime = ' ' + time + '秒'
                  }
                  if (time <= 0) {
                    clearInterval(interval)
                    that.currentTime = ''
                  }
                }, 1000)
              }
            })
            break
            // 绑定手机
          case 'bindMobile':
            httper.post('wechat/user/bind-mobile', requestData, res => {
              console.log("res", res)
              if (res.code == 0) {
                localStorage.setItem('mobile', res.data.mobile);
                this.$toast({
                  message: '绑定成功',
                });
                // sessionStorage.removeItem("source")
                // localStorage.removeItem('access_token');
                // localStorage.removeItem('userinfo');
                // sessionStorage.removeItem("city")
                // sessionStorage.removeItem("latitude")
                // sessionStorage.removeItem("longitude")
                // this.$router.push({
                //   path: "/"
                // })
                setTimeout(() => {
                  history.back()
                }, 1000)
              } else {
                this.$toast({
                  message: res.message || '操作失败',
                });
              }
            }, true)
            break
        }
      },
    }
  }
</script>
<style>
.van-popup--center {
  width: calc(100% - 40px);
  border-radius: 10px;
}
  .banner_logo {
    width: 100%;
    height: 180px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .banner_icon {
    width: 162px;
    /* height:123px; */
  }

  .changephone_center {
    position: fixed;
    top: 30%;
    width: 100%;
  }

  .phone_inputfrom {
    width: 80%;
    padding: 20px 40px;
  }

  .phone_text {
    font-size: 16px;
    font-weight: 400;
    color: rgba(54, 54, 54, 1);
  }

  .phone_input {
    width: 100%;
    border: none;
    border-bottom: 1px solid #dedede;
  }

  .yanzheng_inputfrom {
    width: 80%;
    padding: 0 40px;
  }

  .yanzheng_input {
    display: flex;

  }

  .yanzheng_inputyz {
    border: none;
    border-bottom: 1px solid #dedede;
    width: 70%;
  }

  .yanzheng_get {
    width: 100px;
    height: 31px;
    border: 1px solid #FD8C00;
    border-radius: 15px;
    font-size: 14px;
    font-weight: 400;
    color: #FD8C00;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
  }

  .change_tijiao {
    margin-top: 20px;
  }

  input {
    background: none;
  }

  ::-webkit-input-placeholder {
    text-align: start;
    color: rgba(187, 187, 187, 1);
    font-size: 16px;
  }
  .change_mesg {
    width: 89%;
    padding: 20px;
    margin-top: 20px;
  }

  .change_mesgtitle {
    display: flex;
  }

  .change_mesgimg {
    width: 4px;
    height: 23px;
    margin-right: 10px;
  }

  .change_mesgtext {}

  .change_mesgtip {
    margin-left: 20px;
  }

  .change_mesgtipspan {
    margin-left: 20px;
    color: #FD8C00;
  }

  .change_mesgtipspan1 {
    color: #FD8C00;
  }

  .change_mesgtipspan2 {
    margin-left: 20px;
    font-weight: bold;
    font-size: 18px;
    color: #FD8C00;
  }
  .xieyibox {
    width: calc(100% - 40px);
    display: flex;
    align-items: center;
    margin: 30px 20px 0;
  }
  .xieyiimg {
    width: 15px;
    height: 15px;
    margin-right: 5px;
  }
  .xieyitest {
    font-size: 14px;
  }
  .yinsibox{
    width: calc(100% - 40px);
    margin: 20px;
    border-radius: 10px;
    background-color: #FFFFFF;
    padding: 20px;
    box-sizing: border-box;
  }
  .yinsititle{
    font-size: 15px;
    margin-bottom: 10px;
    text-align: center;
  }
  .yinsidetail{
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/changePhoneNum.vue